import api from "@/services/api.service";
import demoView from "@/demo/demoView";
import {analyticsPayload, receptionPayload} from "@/demo/demoData";


export const realEstatesContractsStatsModule = {
    namespaced: true,
    actions: {
        getCheckinStats(actions, request) {
            request = (request || {});
            request.buids= actions.rootGetters['data/getSelectedBranchesIds'];
            return new Promise(function (resolve, reject) {
                api.sendRequest('realEstate/contract/stats/checkin', null, request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        /** Analytics hub: every KPI + list of the new dashboard in ONE response. */
        getAnalytics(actions, request) {
            if (demoView.enabled()) return Promise.resolve(analyticsPayload(request));
            request = (request || {});
            request.buids = actions.rootGetters['data/getSelectedBranchesIds'];
            return new Promise(function (resolve, reject) {
                api.sendRequest('realEstate/contract/stats/analytics', null, request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        /** Reception block, loaded lazily — Twilio call counts take seconds. */
        getAnalyticsReception(actions, request) {
            if (demoView.enabled()) return Promise.resolve({Reception: receptionPayload()});
            request = (request || {});
            request.buids = actions.rootGetters['data/getSelectedBranchesIds'];
            return new Promise(function (resolve, reject) {
                api.sendRequest('realEstate/contract/stats/analytics/reception', null, request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        getExpensesStats(actions, request) {
            request = (request || {});
            request.buids= actions.rootGetters['data/getSelectedBranchesIds'];
            return new Promise(function (resolve, reject) {
                api.sendRequest('realEstate/contract/stats/expenses', null, request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        getExpensesStatsReport(actions, request) {
            let $this = this;
            request = (request || {});
            request.buids= actions.rootGetters['data/getSelectedBranchesIds'];
            return new Promise(function (resolve, reject) {
                $this.$api.downloadApi().post('realEstate/contract/stats/expenses/report', request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        }
    }
}
